import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { LookupResult } from 'src/app/models/shortcodes.model';
import { ShortCodesService } from 'src/app/services/shortcodes.service';
import { Router } from '@angular/router';
import { ScrBaseResponse, ScrBaseService } from 'src/app/services/base.service';
import { DialogEvent, DynamicDialogComponent } from '../../../custom-controls/dynamic-dialog/dynamic-dialog.component';
import { VetResultsDialogComponent } from '../../../../shared/vet-results-dialog/vet-results-dialog.component';
import { Partner } from '../../../../models/partner.model';
import { DialogName } from '../../../../models/constants';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  templateUrl: './code-lookup.component.html',
  styleUrls: ['./code-lookup.component.scss']
})
export class CodeLookupComponent extends ScrBaseComponent implements OnInit {

  shortCodeValue!: string;
  shortCodeDisplay?: number;
  showData = false;
  searchShortCodeValue = '';
  shortCodeDetail!: LookupResult;
  isErrorLinkVisible = false;
  preErrorMessage = '';
  errorDisplayShortCode = '';
  errorMessage?: string;

  @ViewChild(DynamicDialogComponent) dd!: DynamicDialogComponent;

  constructor(private shortCodesService: ShortCodesService, private router: Router) {
    super();
  }

  ngOnInit(): void {

    if (history.state?.shortCode) {
      this.shortCodeValue = history.state.shortCode.toString();
      this.fetchScDetails();
    }
  }

  fetchScDetails(): void {
    this.isErrorLinkVisible = false;
    this.searchShortCodeValue = ScrBaseService.shortCodeToNumeric(this.shortCodeValue);
    if (ScrBaseService.isInvalidShortCode(this.shortCodeValue)) {
      this.displayLocalizedError("scr.shortcode.invalid");
      const elmt = document.getElementById('messages');
      elmt?.scrollIntoView({ behavior: "smooth" });
      return;
    }

    const strRegex = new RegExp("^[a-zA-Z2-9*][a-zA-Z0-9*]{4,5}$");

    // match the regex with the string
    const result = strRegex.test(this.shortCodeValue);
    if (!result) {
      this.displayLocalizedError("scr.shortcode.invalid");
      return;
    }
    this.showData = false;

    this.observe(this.shortCodesService.shortCodeLookup(this.searchShortCodeValue), {
      onSuccess: (res) => {
        this.errorMessage = undefined;
        if (res.messages && res.messages.length) {
          this.errorDisplayShortCode = this.shortCodeValue;

          this.preErrorMessage = this.translate.instant("scr.tc.shortcode", {}) as string;
          if (res.data.scStatus === 'Available') {
            this.errorMessage = this.translate.instant("scr.error.available", {}) as string;
          }
          else if (res.data.scStatus === 'Reserved') {
            this.errorMessage = this.translate.instant("scr.error.reserved", {}) as string;
          }
          else {
            this.shortCodeDetail = res.data;
            this.shortCodeDisplay = this.shortCodeDetail.scId;
            this.showData = true;
          }
        }

        return false;
      }
    });

  }

  closeError() {
    this.isErrorLinkVisible = false;
  }

  submit(form: NgForm) {
    if (!form.valid) {
      this.scrollToFirstError();
      return;
    }
    this.fetchScDetails();
  }

  getSCHistory(shortCode: string) {
    this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['code-management', { outlets: { 'code-management-tab': ['code-history'] } }] } }], { state: { shortCode: shortCode } });
  }

  showViewResultsLink(partner: Partner | undefined): boolean {
    if (!partner) return false;
    return (partner.vetStatus !== 'Hold Vetting' &&
      ((partner.vetResults?.findings !== undefined && partner.vetResults?.findings.length > 0) || partner.vetResults?.errorDescription !== undefined));
  }

  viewVetResults(event: MouseEvent, partner?: Partner): void {
    event.preventDefault();
    if (partner) {
      this.dd.show(VetResultsDialogComponent, {
        vetStatus: partner.vetStatus,
        vetReportId: partner.vetReportId,
        vetDate: partner.vetStatusUpdateTime,
        findings: partner.vetResults?.findings,
        errorDescription: partner.vetResults?.errorDescription,
        entityName: partner.company,
        entityType: partner.partnerType
      });
    }
  }

  onDialogComplete(e: DialogEvent): void {

    if (e.error instanceof HttpErrorResponse) {
      this.doHttpError(e.error);
    }
    else if (e.error instanceof ScrBaseResponse) {
      this.processScrErrorResponse(e.error);
    }

    switch (e.name) {

      case DialogName.VetResults:
        // anything to do ?
        break;

      default:
        console.warn('unexpected callback name ' + e.name);
        break;
    }
  }
}
